var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('FormatSelect', {
    attrs: {
      "formats": _vm.formatItems,
      "actions": _vm.plainActions,
      "value": _vm.innerValue,
      "label": _vm.label,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "loading": _vm.loading,
      "dense": _vm.dense,
      "outlined": _vm.outlined,
      "filled": _vm.filled,
      "hide-details": _vm.hideDetails,
      "show-unit-option": false,
      "show-custom-option": false,
      "show-create-option": false,
      "kind-first": ""
    },
    on: {
      "input": _vm.onInput,
      "keydown": function keydown($event) {
        return _vm.$emit('keydown', $event);
      },
      "blur": function blur($event) {
        return _vm.$emit('blur');
      }
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }